module.exports = __webpack_public_path__ + "static/media/kimgreatsitkin.67da6776.png";